import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss',
    "../../_shared/styles/modals.scss"
  ]
})
export class ContactoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
